import React from "react";
import Modal from "./modal";

const ErrorMsgModal = ({errorMsg,closeHandler}) => {
  return (
    <Modal
      label={"Alert"}
      onlyClose={true}
      showHide={closeHandler}
      size={"md"}
      center={true}
    >
      <div className="toast-body">
        <h4 className="d-flex gap-3" style={{ textDecoration: "none" }}>
          <i
            class="fa fa-times-circle red-icon"
            style={{ fontSize: "25px" }}
            aria-hidden="true"
          ></i>
          {errorMsg}
        </h4>
      </div>
    </Modal>
  );
};

export default ErrorMsgModal;
